import moment from "moment-timezone";
import { isDateStringToday } from "@src/common/lib/DateUtils";

/**
 * Combines a base time moment with a selected date string.
 * If the selected date is not today, creates a new moment with that date
 * while preserving the time components from the base moment.
 *
 * @param baseTimeMoment - The moment containing the time to use
 * @param selectedStopDate - Optional date string in "YYYY-MM-DD" format
 * @returns A moment with the selected date and base time, or the original moment if date is today
 */
export function getEffectiveBaseTime(
  baseTimeMoment: moment.Moment,
  selectedStopDate: string | undefined
): moment.Moment {
  if (!isDateStringToday(selectedStopDate) && selectedStopDate) {
    return moment(selectedStopDate, "YYYY-MM-DD")
      .hour(baseTimeMoment.hour())
      .minute(baseTimeMoment.minute())
      .second(baseTimeMoment.second());
  }
  return baseTimeMoment;
}
